import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"drumstick"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.0006 16C18.8666 16 22.0006 12.866 22.0006 9C22.0006 5.13401 18.8666 2 15.0006 2C11.1346 2 8.00059 5.13401 8.00059 9C8.00059 9.47609 8.04812 9.94108 8.13869 10.3905L6.50059 12C5.90715 12.5934 6.11819 13.8145 6.94472 15.0607C7.20602 15.4547 7.53958 15.8674 7.9148 16.2426C8.23308 16.5609 8.58176 16.8522 8.91574 17.0893C10.2209 18.0156 11.5355 18.2788 12.1574 17.6569L13.927 15.9182C14.277 15.9721 14.6355 16 15.0006 16Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5.5004 21.9999C3.96067 22.0396 4.0004 19.9999 4.0004 19.9999C4.0004 19.9999 1.96711 20.0333 2.0004 18.4999C2.0337 16.9664 3.90906 16.9999 5.0004 16.9999L6.94455 15.0605C7.20585 15.4545 7.53941 15.8673 7.91463 16.2425C8.2329 16.5608 8.58159 16.8521 8.91556 17.0891L7.0004 18.9999C7.0004 20.0991 7.04014 21.9601 5.5004 21.9999Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.5004 21.9999C3.96067 22.0396 4.0004 19.9999 4.0004 19.9999C4.0004 19.9999 1.96711 20.0333 2.0004 18.4999C2.0337 16.9664 3.90906 16.9999 5.0004 16.9999L6.94455 15.0605C7.20585 15.4545 7.53941 15.8673 7.91463 16.2425C8.2329 16.5608 8.58159 16.8521 8.91556 17.0891L7.0004 18.9999C7.0004 20.0991 7.04014 21.9601 5.5004 21.9999Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.1007 14C9.24002 13.1567 8.5962 12.0929 8.26057 10.9M8.91464 17.0891C8.58067 16.8521 8.23198 16.5608 7.91371 16.2425C7.53849 15.8673 7.20493 15.4545 6.94363 15.0605C6.1171 13.8143 5.90623 12.5934 6.49967 12L8.13777 10.3905C8.0472 9.94108 7.99967 9.47609 7.99967 9C7.99967 5.13401 11.1337 2 14.9997 2C18.8657 2 21.9997 5.13401 21.9997 9C21.9997 12.866 18.8657 16 14.9997 16C14.6346 16 14.2761 15.9721 13.9261 15.9182L12.1565 17.6569C11.5346 18.2788 10.2198 18.0155 8.91464 17.0891Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Drumstick = Vue.extend<IconProps>({
  name: 'DrumstickIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'drumstick',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Drumstick;
